<template>
  <page-outline :title="$t('Webheader.requester_list_tb')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <RequestTBList></RequestTBList>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import RequesterTbList from './RequesterTBList.vue'


export default {
  name: 'RequestTBPage',
  components: {
    RequestTBList: RequesterTbList,
    'page-outline': PageOutline,
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
  },
  data () {
    return {
      activateSpinner: false,
    }
  },
  created () {
    this.$bus.$emit('switch-selected-menu', '/tracking/' + this.type + '/' + this.id)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
}
</script>
